export enum MainMenu {
  None = 0,
  ExternalServices = 1,
  User = 2,
  NewReports = 3
}
